module.exports = __webpack_public_path__ + "img/dirty_stainless_steel.077ad832.svg";